var React = require('react');

function PathKlein (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0pathk{fill:none;stroke:#1D1D1B;stroke-width:12;stroke-linecap:round;stroke-miterlimit:1;stroke-dasharray:0,25;}\n"),React.createElement("g",{"key":1},[React.createElement("path",{"className":"st0pathk","d":"M1695.1,958.5c202-51,418.3,192.5,350.7,309.2","key":0}),React.createElement("path",{"className":"st0pathk","d":"M2045.8,1267.7c-820.6,148.6-789.2,706.9-779.1,818.5","key":1}),React.createElement("path",{"className":"st0pathk","d":"M1266.6,2086.2c-418.6-88.6-603.1-641.1-535.2-972.4","key":2})])]);
}

PathKlein.defaultProps = {"version":"1.1","id":"Ebene_2","x":"0px","y":"0px","viewBox":"0 0 2864.7 2706.3","style":{"enableBackground":"new 0 0 2864.7 2706.3"},"xmlSpace":"preserve"};

module.exports = PathKlein;

PathKlein.default = PathKlein;
